export enum MEDIATYPES {
	GIF = 'image/gif',
	JPEG = 'image/jpeg',
	MP4 = 'video/mp4',
	PNG = 'image/png',
	TIFF = 'image/tiff',
}
